import * as React from 'react';

import { Checkbox, Title } from 'common/components';
import { FieldsGrid, GridItem, Section } from 'templates/core';
import { Fields, StatusOption } from '../types';
import { useWatch } from 'react-hook-form';
import { STATUSES } from '../consts';

interface ExploreFieldsProps {
  fields: Fields<{
    is_featured: boolean;
    is_inspiration: boolean;
    status: StatusOption[];
  }>;
}

const ExplorePageFields = ({ fields }: ExploreFieldsProps) => {
  const status = useWatch<StatusOption[]>({ name: fields.status.name });
  const isActive = status && status[0].value === STATUSES.ACTIVE;

  return (
    <Section>
      <Title marginBottom={2.5}>Explore Page</Title>
      <FieldsGrid>
        <GridItem>
          <Checkbox
            name={fields.is_featured.name}
            label={fields.is_featured.label}
            dimmed
            disabled={!isActive}
          />
        </GridItem>
        <GridItem>
          <Checkbox
            name={fields.is_inspiration.name}
            label={fields.is_inspiration.label}
            dimmed
            disabled={!isActive}
          />
        </GridItem>
      </FieldsGrid>
    </Section>
  );
};

export default ExplorePageFields;
